import { render, staticRenderFns } from "./addNewCollege.vue?vue&type=template&id=556811cd&scoped=true&"
import script from "./addNewCollege.vue?vue&type=script&lang=js&"
export * from "./addNewCollege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556811cd",
  null
  
)

export default component.exports